import { Map, List, fromJS } from 'immutable'

import {
  SET_GROUPS,
  SET_DEFAULT_GROUPS,
  SET_GROUP,
  UPDATE_GROUP,
  DELETE_GROUP,
  SET_GROUP_MEMBERS,
  SET_GROUP_MEMBERSHIP_LOGS,
  SET_GROUP_POLICY_DATA,
  SET_DEFAULT_GROUP_MEMBERS,
  SET_GROUP_MEMBERSHIP_DATA,
  SET_GROUP_MEMBERS_FILTERS,
  GROUPS_LOADED,
  CLEAR_GROUPS,
  LOADING_GROUPS_FILTERS,
  SET_AVAILABLE_FILTERS
} from '../actions'

export const initialState = new Map({
  groups: new List(),
  departments: new List(),
  locations: new List(),
  custom: new List(),
  count: 0,
  departments_count: 0,
  locations_count: 0,
  custom_count: 0,
  next: null,
  previous: null,
  loaded: false,
  default_groups: new List(),
  selected_def_group_members: new List(),
  selected_def_group_count: 0,
  membersFilters: new Map(),
  isLoadingAvailableFilters: false,
  availableFilters: new Map()
})

const groupsReducer = (state = initialState, action = {}) => {
  let indexOfListToUpdate = null

  switch (action.type) {
    case SET_GROUPS: {
      return state
        .set('groups', fromJS(action.data.results))
        .set('count', action.data.count)
        .set('next', action.data.next)
        .set('loaded', true)
    }

    case CLEAR_GROUPS: {
      return state.set('groups', fromJS([])).set('loaded', false)
    }

    case SET_GROUP:
      return state.set('groups', state.get('groups').push(fromJS(action.data))).set('loaded', true)

    case UPDATE_GROUP:
      indexOfListToUpdate = state
        .get('groups')
        .findIndex((group) => group.get('id') === action.groupId)
      return state.setIn(['groups', indexOfListToUpdate], fromJS(action.data))

    case DELETE_GROUP:
      indexOfListToUpdate = state
        .get('groups')
        .findIndex((group) => group.get('id') === action.groupId)
      return state.removeIn(['groups', indexOfListToUpdate])

    case SET_GROUP_MEMBERS:
      indexOfListToUpdate = state
        .get('groups')
        .findIndex((group) => group.get('id') === action.groupId)
      return state
        .setIn(['groups', indexOfListToUpdate, 'members'], fromJS(action.data.results))
        .setIn(['groups', indexOfListToUpdate, 'memberCount'], fromJS(action.data.count))

    case SET_GROUP_MEMBERSHIP_LOGS:
      indexOfListToUpdate = state
        .get('groups')
        .findIndex((group) => group.get('id') === action.groupId)
      return state
        .setIn(['groups', indexOfListToUpdate, 'membershipLogs'], fromJS(action.data.results))
        .setIn(['groups', indexOfListToUpdate, 'membershipLogsCount'], fromJS(action.data.count))

    case SET_GROUP_MEMBERSHIP_DATA: {
      indexOfListToUpdate = state
        .get('groups')
        .findIndex((group) => group.get('id') === action.groupId)

      let membershipLogs = state.getIn(['groups', indexOfListToUpdate, 'membershipLogs'])
      action?.data?.results?.forEach((result) => {
        let index = null
        do {
          index = membershipLogs.findIndex(
            (log) => log.get('policy_id') === result.id && log.get('operator') === null
          )
          if (index !== -1) {
            const log = state.getIn(['groups', indexOfListToUpdate, 'membershipLogs', index])
            membershipLogs = membershipLogs.setIn([index], log.set('operator', result.name))
          }
        } while (index !== -1)
      })
      const groups = state.get('groups')
      return state.set(
        'groups',
        groups.update(indexOfListToUpdate, (item) => item.set('membershipLogs', membershipLogs))
      )
    }

    case SET_GROUP_POLICY_DATA:
      indexOfListToUpdate = state
        .get('groups')
        .findIndex((group) => group.get('id') === action.groupId)
      return state.setIn(['groups', indexOfListToUpdate, 'links'], fromJS(action.data.results))

    case SET_GROUP_MEMBERS_FILTERS:
      return state.set('membersFilters', fromJS(action.data))

    case SET_DEFAULT_GROUP_MEMBERS:
      return state
        .set('selected_def_group_members', fromJS(action.data.results))
        .set('selected_def_group_count', fromJS(action.data.count))

    case SET_DEFAULT_GROUPS:
      return state.set('default_groups', fromJS(action.data.results))

    case GROUPS_LOADED:
      return state.set('loaded', action.isLoaded)

    case LOADING_GROUPS_FILTERS:
      return state.set('isLoadingAvailableFilters', action.isLoadingAvailableFilters)

    case SET_AVAILABLE_FILTERS:
      return state
        .set('availableFilters', fromJS(action.data))
        .set('isLoadingAvailableFilters', false)

    default:
      return state
  }
}

export default groupsReducer
